export const NETWORK_START_PAGES = {
    'NETWORK_PAGE': '1',
};
